import { render, staticRenderFns } from "./EditorTask.vue?vue&type=template&id=4535a462"
import script from "./EditorTask.vue?vue&type=script&lang=js"
export * from "./EditorTask.vue?vue&type=script&lang=js"
import style0 from "./EditorTask.vue?vue&type=style&index=0&id=4535a462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports